import { useEffect, useState } from "react";
import { BellRing, Send } from "lucide-react";
import { api, dateTime, errMsg } from "../../lib/api";

const channelText = (v) => (!v ? "—" : v === "sent" ? "Terkirim" : v.startsWith("skipped") ? "Belum dikonfigurasi" : `Gagal (${v.replace("failed:", "")})`);

export const NotificationSettings = ({ settings, form, set, onSave }) => {
  const [log, setLog] = useState([]);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/notifications").then((r) => setLog(r.data));
  useEffect(() => { load(); }, []);
  const test = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/notifications/test");
      setMsg(`Email: ${channelText(r.data.email)} · WhatsApp: ${channelText(r.data.whatsapp)}`);
      load();
    } catch (err) {
      setMsg(errMsg(err, "Tes notifikasi gagal"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="panel integration-card mt">
      <div className="panel-head">
        <div><p className="eyebrow">NOTIFIKASI</p><h3>Email & WhatsApp</h3></div>
        <span className={settings?.whatsapp_configured ? "pill ok" : "pill warn"} data-testid="whatsapp-config-status">WhatsApp {settings?.whatsapp_configured ? "aktif" : "pending"}</span>
      </div>
      <p className="muted">Email (Resend) sudah aktif otomatis. WhatsApp dikirim via Twilio — isi Account SID, Auth Token, dan nomor pengirim WhatsApp Twilio (format +14155238886).</p>
      <div className="three-fields">
        <label>Twilio Account SID<input value={form.twilio_sid ?? settings?.twilio_sid ?? ""} onChange={set("twilio_sid")} data-testid="admin-twilio-sid-input" /></label>
        <label>Twilio Auth Token<input type="password" value={form.twilio_token || ""} placeholder={settings?.whatsapp_configured ? "•••• tersimpan" : "Auth token"} onChange={set("twilio_token")} data-testid="admin-twilio-token-input" /></label>
        <label>Nomor WhatsApp pengirim<input value={form.twilio_from ?? settings?.twilio_from ?? ""} placeholder="+14155238886" onChange={set("twilio_from")} data-testid="admin-twilio-from-input" /></label>
      </div>
      <div className="row-actions">
        <button type="button" className="primary" onClick={() => onSave()} data-testid="admin-save-whatsapp-button">Simpan WhatsApp</button>
        <button type="button" className="outline" disabled={busy} onClick={test} data-testid="admin-test-notification-button"><Send size={14} /> {busy ? "Mengirim…" : "Kirim tes ke saya"}</button>
        {msg && <small className={msg.includes("Gagal") ? "integration-message down" : "integration-message"} data-testid="admin-test-notification-result">{msg}</small>}
      </div>
      <div className="notif-log">
        <p className="eyebrow"><BellRing size={11} /> LOG TERAKHIR</p>
        {log.slice(0, 8).map((n, i) => (
          <div className="notif-row" key={i}><span>{dateTime(n.created_at)}</span><span>{n.title}</span><span>Email: {channelText(n.email)}</span><span>WA: {channelText(n.whatsapp)}</span></div>
        ))}
        {log.length === 0 && <p className="muted">Belum ada notifikasi terkirim.</p>}
      </div>
    </section>
  );
};
